module.exports = __webpack_public_path__ + "img/4cd55b3c315cd439d6739d5230809222.png";